import React from 'react';
import './Loading.css';
import '../../assets/scss/font-icon.css';
import { ScaleLoader } from 'react-spinners';

let Loading = () => {
    return (
        <div className="loading-wrapper">
            <i className="icon-facebook" />
            <p>
                Logging in with Facebook
                <span>please wait...</span>
            </p>
            <ScaleLoader color={'#fff'} loading={true} size={10} />
        </div>
    );
};

export default Loading;


// WEBPACK FOOTER //
// ./src/components/Loading/Loading.jsx